import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div
      className="info"
      style={{ backgroundColor: "white", alignItems: "flex-end" }}
    >
      <div className="heading-container">
        <div className="heading">Nurturing Nature, Respecting Resources, A Sunday for Sustainability! </div>
        Day 4
        <div className="heading-line"></div>
      </div>
      <div className="text1">
      We will also emphasise the importance of reducing food and water waste in our mess facilities. The
Dean of Student Affairs will appeal to students to serve small portions and avoid along with wardens
of respective hostels.
Sunday will also be the last day of submission of entries for the E-poster competition
      </div>
      {/* <div className="text2">
        They are also encouraged to take a screenshot and upload the same to the
        given link :
      </div>
      <div className="text3">
        The lecture “Tirange ki Kahani” will be given by an eminent personality
        in online mode at :
      </div> */}
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 4 June, 2023
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;
